import {cpServiceV2Get} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import {
    GetMultiDayDiscountRequestParams,
    MultiDayDiscountsResponseData,
    RawMultiDayDiscountsResponse,
} from 'api/rates/multi-day-discounts/multi-day-discounts.types';

/**
 * Formats the response data for multi-day discounts.
 */
const formatMultiDayDiscountsResponse = (
    data: RawMultiDayDiscountsResponse
) => {
    const formattedResponse: MultiDayDiscountsResponseData = camelizeKeys(data);

    return formattedResponse;
};

/**
 * Fetches multi-day discounts for a facility's rating rule group.
 */
const getMultiDayDiscounts = async ({
    facilityId,
    ruleGroupId,
}: GetMultiDayDiscountRequestParams) => {
    try {
        const response = await cpServiceV2Get<RawMultiDayDiscountsResponse>(
            `facilities/${facilityId}/rating-rule-groups/${ruleGroupId}/discounts`
        );

        const formattedResponse = formatMultiDayDiscountsResponse(
            response.data.data
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default getMultiDayDiscounts;
